import React from "react";
import { IRoute } from "./interfaces/route.interface";

const AdminsPage = React.lazy(() =>  import("../pages/AdminsPage"));

export const adminRoutes:IRoute[] = [
    {
        path: "/admins",
        exact: true,
        component: AdminsPage,
        privateRoute: true,
    }
];